import { useMutation, useQueryClient } from '@tanstack/react-query';
import GeospatialQueries, { GEOSPATIAL_QUERY_KEYS } from '../query';
import type { GeocodeResponse } from '../types';

type AddressValidationResult = {
  isValid: boolean;
  suggestions: GeocodeResponse['candidates'];
};

export const useAddressValidationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ address }: { address: string }): Promise<AddressValidationResult> => {
      const results = await GeospatialQueries.findAddressCandidates(address);

      return {
        isValid: results.candidates.some((candidate) => candidate.score >= 90),
        suggestions: results.candidates,
      };
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData([GEOSPATIAL_QUERY_KEYS.VALIDATE_ADDRESS, variables.address], data);
    },
    onError: (error) => {
      console.error('Address validation mutation failed:', error);
    },
  });
};
